import script from "./cardManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./cardManagement.vue?vue&type=script&setup=true&lang=js"

import "./cardManagement.vue?vue&type=style&index=0&id=51226509&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51226509"]])

export default __exports__